import { Product, ProductCategories, ProductPrice } from "src/api/types";
import { mapNumberOfMonthsToDays } from "src/constants/mapNumberOfMonthsToDays";

const glp1InjectableNames = [
  "Semaglutide",
  "Semaglutide OT",
  "Tirzepatide",
  "Tirzepatide OT",
];

export const useGetDaysSupply = (
  product: Product | null,
  price?: ProductPrice | null,
) => {
  if (price == null || product == null) return undefined;

  if (
    product.category.name === ProductCategories.WeightLoss &&
    glp1InjectableNames.includes(product.name)
  ) {
    return mapNumberOfMonthsToDays[price.number_of_months];
  }

  return price.interval_count;
};
